import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  padding: 4px;
  background: ${props => props.theme.background};
`
export const BannerSection = styled.div`
  width: 100%;
  display: flex;

  ${Media.Tablet` 
    flex-direction: column-reverse; 
  `};
`
export const ActionSection = styled.div`
  width: 100%;
  display: flex;
  border-radius: 15px;
  padding: 32px 40px;
  background: white;
  gap: 32px;

  ${Media.Tablet` 
    flex-direction: column; 
    gap: 24px;
    padding: 32px 28px;
  `};

  ${Media.Phone`
    gap: 18px;
    padding: 16px;
  `};
`
export const Header = styled.div`
  flex: 1;
  padding: 44px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${Media.Tablet`
    padding: 24px 32px;
  `};

  ${Media.Phone`
    padding: 4px 16px 12px;
  `};
`
export const Title = styled.h2`
  ${Typography.S}
  ${FontWeights.Medium}
  color: ${props => props.theme.text};
`
export const Description = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}
  color: ${props => props.theme.text};
  margin: 0;
`
export const ImageWrapper = styled.div`
  flex: 1;
  padding: 0 32px 0 0;
  max-height: 180px;

  ${Media.Tablet`
    padding: 0;
  `};
`

export const Image = styled.img`
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`
export const VideoWrapper = styled.div`
  flex: 1;
  display: flex;

  max-height: 180px;
  margin: 16px 32px 16px 0;
  overflow: hidden;

  ${Media.Tablet`
    flex: unset;
    margin: 8px 0;
    justify-content: center;
  `};
`
export const Video = styled.video`
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border: none;
  // This negative margin is to hide the left border of the video
  margin-left: -3px;

  ${Media.Tablet`
    max-width: 511px;
    height: 180px;
  `};

  ${Media.Phone`
    max-width: 335px;
    height: 134px;
  `};
`
export const List = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;

  ${Media.Tablet` 
    flex-direction: column; 
    align-items: flex-start;
    gap: 16px;
  `};

  ${Media.Phone`
    gap: 8px;
  `};
`
export const Item = styled.div`
  flex: 1;
  display: flex;
  gap: 8px;
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral80};

  & svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
`
export const Action = styled.div`
  ${Media.Tablet` 
    width: 100%; 
    a { 
      width: 100%; 
    } 
  `}
`
